"use client";
import React from "react";
import Image from "next/image";
import { BANDERAS, CANTIDAD_DE_IDIOMAS } from "@/lib/banderas";
import "./barra-numeros.css";

// Barra negra de números: dos datos de la página y, al final, la cantidad de idiomas con
// sus banderas (el número y la lista salen de lib/banderas.js). En el celular van los dos
// datos arriba, lado a lado, y los idiomas en un renglón fino debajo con las banderas al
// lado; el porqué está en barra-numeros.css.
//
// datos: [{ numero, etiqueta, instagram?, anchoMaximo? }], siempre DOS (la grilla del
// celular es de dos columnas). `instagram` dibuja el ícono al lado del número.
// `anchoMaximo` (px) es para una etiqueta larga, que en escritorio tiene que cortar en vez
// de mandar el último dato al renglón de abajo.

export default function BarraNumeros({ datos, idiomas }) {
  return (
    <section className="bn-seccion">
      <div className="bn-fila">
        {datos.map((dato) => (
          <div key={dato.etiqueta} className="bn-dato" style={dato.anchoMaximo ? { maxWidth: dato.anchoMaximo } : undefined}>
            <div className="bn-numero">
              {dato.numero}
              {dato.instagram && (
                <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <rect x="2" y="2" width="20" height="20" rx="5" stroke="#999" strokeWidth="1.5" />
                  <circle cx="12" cy="12" r="5" stroke="#999" strokeWidth="1.5" />
                  <circle cx="17.5" cy="6.5" r="1.5" fill="#999" />
                </svg>
              )}
            </div>
            <div className="bn-etiqueta">{dato.etiqueta}</div>
          </div>
        ))}
        <div className="bn-idiomas">
          <div className="bn-dato">
            <div className="bn-numero">{CANTIDAD_DE_IDIOMAS}</div>
            <div className="bn-etiqueta">{idiomas}</div>
          </div>
          <div className="bn-banderas">
            {BANDERAS.map((flag) => (
              <Image key={flag} className="bn-bandera" src={`/assets/images/flags/${flag}.png`} alt="" width={28} height={28} quality={60} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
